import styled from 'styled-components';

export const PlayerSambaVideosContainer = styled.div`
  height: 100%;
  width: 100%;
`;
